import styled, { css } from 'styled-components'

import { theme } from '../../../theme'

import type { StyledTextAreaProps } from './types'

export const TextArea = styled.textarea<StyledTextAreaProps>`
  box-sizing: border-box;
  font-family: ${theme.fonts.mainFont};
  font-size: 16px;
  font-weight: normal;
  line-height: 1.2;
  color: ${({ readOnly }) =>
    readOnly ? theme.colors.slateGray : theme.colors.sapphireDark};
  background: ${theme.colors.white};
  border: 1px solid ${theme.colors.crystalBay};
  border-radius: 8px;
  padding: 14px;
  min-height: ${({ $scrollHeight, $shouldExpandWithText }) =>
    $shouldExpandWithText ? $scrollHeight : '90'}px;
  ${({ $canBeManuallyResized }) =>
    !$canBeManuallyResized &&
    css`
      resize: none;
      overflow: hidden;
    `}

  width: 100%;
  transition:
    border-color,
    ease 350ms;

  :focus {
    border-color: ${theme.colors.second};
  }

  :read-only {
    background: ${theme.colors.catskillWhite};
  }

  ::placeholder {
    color: ${theme.colors.blueAura};
  }

  :disabled {
    color: ${theme.colors.slateGray};
  }

  ${({ $error }) =>
    $error &&
    css`
      border-color: ${theme.colors.danger};
    `}
`

export const TextAreaWrapper = styled.div`
  position: relative;
`
